import React, { useState } from "react";
import {
  Box,
  Stack,
  Step,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import * as SC from "SC";
import { VehicleStep } from "./onboarding/VehicleStep";
import { InviteStep } from "./onboarding/InviteStep";

const STEPS = [
  "Company Setup",
  "Admin Account",
  "Payment",
  "Add Vehicle",
  "Invite Team",
];

/**
 * Shown after a successful Stripe Checkout payment.
 * Stripe redirects to: /onboarding/success?session_id=...
 * Continues the onboarding wizard at steps 4 (vehicle) and 5 (invites).
 */
export const OnboardingSuccessPage = () => {
  const [activeStep, setActiveStep] = useState(3);
  const [doneState, setDoneState] = useState({ vehicle: false, invites: false });

  const handleVehicleDone = () => {
    setDoneState((s) => ({ ...s, vehicle: true }));
    setActiveStep(4);
  };
  const handleVehicleSkip = () => setActiveStep(4);

  const handleInvitesDone = () => {
    setDoneState((s) => ({ ...s, invites: true }));
    setActiveStep(5);
  };
  const handleInvitesSkip = () => setActiveStep(5);

  return (
    <SC.AuthFormContainer sx={{ maxWidth: "720px", width: "100%", alignSelf: "center" }}>
      <Stack gap={3}>
        <Stack alignItems="center" gap={0.5}>
          <Typography variant="h5" fontWeight={800} color="primary.main">
            FleetMD
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Almost there — a few finishing touches.
          </Typography>
        </Stack>

        <Stepper activeStep={activeStep} alternativeLabel>
          {STEPS.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>

        <Box>
          {activeStep === 3 && (
            <VehicleStep onDone={handleVehicleDone} onSkip={handleVehicleSkip} />
          )}
          {activeStep === 4 && (
            <InviteStep onDone={handleInvitesDone} onSkip={handleInvitesSkip} />
          )}
          {activeStep >= 5 && (
            <Stack gap={3} alignItems="center" sx={{ textAlign: "center", py: 4 }}>
              <CheckCircleIcon sx={{ fontSize: 72, color: "success.main" }} />
              <Stack gap={1}>
                <Typography variant="h5" fontWeight={800}>
                  You're all set! 🎉
                </Typography>
                <Typography variant="body1" color="text.secondary" maxWidth={440}>
                  Your FleetMD account is ready. Sign in to start dispatching rides.
                </Typography>
                {(doneState.vehicle || doneState.invites) && (
                  <Typography variant="caption" color="text.secondary">
                    {doneState.vehicle && "Vehicle saved. "}
                    {doneState.invites && "Invitations sent."}
                  </Typography>
                )}
              </Stack>
              <SC.ControlButton variant="contained" href="/" sx={{ minWidth: 200 }}>
                Go to Login
              </SC.ControlButton>
              <Typography variant="caption" color="text.secondary">
                Need help? Contact{" "}
                <a href="mailto:support@fleetmd.io" style={{ color: "inherit" }}>
                  support@fleetmd.io
                </a>
              </Typography>
            </Stack>
          )}
        </Box>
      </Stack>
    </SC.AuthFormContainer>
  );
};

export default OnboardingSuccessPage;
